module.exports = __webpack_public_path__ + "media/images/announceGroup__bg-9276b0a2a4b7180d02ff872347fb99a5.jpg";